import * as fileActions from './actions';
import * as fileActionTypes from './types';
import fileReducer from './reducers';

const { FILE_INIT_STATE } = fileActionTypes;

export { fileActions, fileActionTypes, fileReducer, FILE_INIT_STATE };
